import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TopChartFilters from "@client.components/TopChartFilters";
import LeftSideBar from "../LeftSideBar";

const ReportsComparisons = () => {
  const [setTopBarTitle] = useOutletContext();
  const { t } = useTranslation();

  useEffect(() => {
    setTopBarTitle(t("components.NavigationBar.reports"));
  }, [t, setTopBarTitle]);

  return (
    <div className="reports">
      <LeftSideBar />
      <div className="reports-content">
        <TopChartFilters />
        <div className="charts">
          <div className="chart-grid">Under construction</div>
        </div>
      </div>
    </div>
  );
};

export default ReportsComparisons;
